import { CustomerQueryKeys } from "../Customer/keys";

export const CustomerUsersQueryKeys = {
  all: (customerId: string) => [
    ...CustomerQueryKeys.single(customerId),
    "users",
  ],
  single: (customerId: string, userId: string) => [
    ...CustomerUsersQueryKeys.all(customerId),
    userId,
  ],
};
